// Cart Page JavaScript
class CartPage {
  constructor() {
    this.promoToggle = document.querySelector('.cart-page__promo-toggle');
    this.promoForm = document.querySelector('.cart-page__promo-form');
    this.promoArrow = this.promoToggle?.querySelector('svg');

    this.init();
  }

  init() {
    if (this.promoToggle && this.promoForm) {
      // Initially hide the form
      this.promoForm.style.display = 'none';
      this.promoToggle.setAttribute('aria-expanded', 'false');
      if (this.promoArrow) this.promoArrow.style.transform = 'rotate(180deg)';

      this.promoToggle.addEventListener('click', () => {
        this.togglePromoForm();
      });
    }
  }

  togglePromoForm() {
    const isVisible = this.promoForm.style.display !== 'none';

    if (isVisible) {
      this.promoForm.style.display = 'none';
      if (this.promoArrow) this.promoArrow.style.transform = 'rotate(180deg)';
      this.promoToggle.setAttribute('aria-expanded', 'false');
    } else {
      this.promoForm.style.display = 'flex';
      if (this.promoArrow) this.promoArrow.style.transform = 'rotate(0deg)';
      this.promoToggle.setAttribute('aria-expanded', 'true');
      // Focus the input field
      const input = this.promoForm.querySelector('.cart-page__promo-input');
      if (input) {
        setTimeout(() => input.focus(), 100);
      }
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CartPage();
});
